import React, { useState } from 'react';

const languages: any = [
  { code: "en", name: "English", flag: "https://flagcdn.com/w320/us.png" },
  { code: "pt-BR", name: "Português (Brasil)", flag: "https://flagcdn.com/w320/br.png" },
  { code: "hr", name: "Hrvatski", flag: "https://flagcdn.com/w320/hr.png" },
];

export default function LanguagePicker({ onChange, initialLanguage }: any) {
  const [selectedLanguage, setSelectedLanguage] = useState(
    languages.find((lang: any) => lang.code === initialLanguage) || languages[0]
  );
  const [isMenuOpened, setMenuOpened] = useState(false);
  
  const handleLanguageChange = (language: any) => {
    setSelectedLanguage(language);
    onChange(language.code);
    setMenuOpened(false);
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button
        id="language-picker"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px",
          fontSize: "16px",
          borderRadius: "5px",
          cursor: "pointer",
          backgroundColor: "#f9f9f9",
          border: "1px solid #ccc",
          minWidth: "80px",
        }}
        onClick={() => {
          setMenuOpened(isOpened => !isOpened);
        }}
      >
        <img
          src={selectedLanguage.flag}
          alt={selectedLanguage.name}
          style={{ width: 20, height: 14, marginRight: 10 }}
        />
        <span style={{ marginLeft: 10 }}>{ isMenuOpened ? '▲' : '▼' }</span>
      </button>
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: 0,
          position: "absolute",
          top: "100%",
          left: 0,
          backgroundColor: "#fff",
          border: "1px solid #ccc",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          zIndex: 20000,
          display: isMenuOpened ? 'block': 'none',
          overflowY: "auto",
          maxHeight: "200px",
          width: '150px'
        }}
        id="language-options"
      >
        {languages.map((lang: any) => (
          <li
            key={lang.code}
            onClick={() => handleLanguageChange(lang)}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px",
              cursor: "pointer",
              transition: "background-color 0.2s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#f0f0f0")}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
          >
            <img
              src={lang.flag}
              alt={lang.name}
              style={{ width: 20, height: 14, marginRight: 10 }}
            />
            {lang.name}
          </li>
        ))}
      </ul>
    </div>
  ); 
}
